export default class CommandCentreViewer extends HTMLElement {
  connectedCallback () {
    this.innerHTML = `
      <div id="cc-overlay" class="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm p-0 sm:p-6 lg:p-[24px] hidden items-center justify-center font-['Raleway']">
        <div class="w-[calc(100%-32px)] mx-4 sm:mx-auto max-w-[1216px] h-[85vh] max-h-[85vh] lg:h-[90vh] lg:max-h-[784px] rounded-[20px] sm:rounded-[24px] bg-white shadow-2xl flex flex-col lg:flex-row overflow-hidden relative">
          
          <!-- 1. Desktop Sidebar (hidden on mobile/tablet < lg) -->
          <div class="hidden lg:flex w-[320px] bg-[#043f42] rounded-l-[24px] p-[24px] flex-col shrink-0">
            <div class="flex items-center gap-[12px] shrink-0 mb-[24px]">
              <h2 class="text-white text-[20px] font-bold font-['Raleway']">Submission Review</h2>
            </div>
            
            <div class="w-full h-[1px] bg-[#ffffff1a] shrink-0 mb-[24px]"></div>

            <div class="flex gap-[8px] mb-[24px] shrink-0 p-[4px] bg-[#022f32] rounded-[12px]">
              <button id="cc-tab-main" class="flex-1 py-[8px] rounded-[8px] text-[12px] font-bold uppercase tracking-wider transition-all bg-[#043f42] text-white shadow-sm">Main</button>
              <button id="cc-tab-attachments" class="flex-1 py-[8px] rounded-[8px] text-[12px] font-bold uppercase tracking-wider transition-all text-[#ffffff80] hover:text-white">Attachments</button>
            </div>

            <div class="flex-1 min-h-0 overflow-y-auto doccu-scrollbar pr-[8px] flex flex-col pt-4" id="cc-sidebar-content" style="-webkit-mask-image: linear-gradient(to bottom, transparent, black 16px); mask-image: linear-gradient(to bottom, transparent, black 16px);">
              <!-- Rendered via JS -->
            </div>
            
            <div class="shrink-0 mt-[24px]" id="cc-sidebar-footer" style="visibility: hidden">
              <a href="#" id="cc-download-attachments" class="w-full bg-[#22ec9b] text-[#043f42] p-[16px] rounded-[8px] flex justify-center items-center font-semibold font-['Raleway'] hover:bg-[#01d680] transition-colors mb-[16px]">
                Download Attachments
              </a>
            </div>

            <div class="shrink-0 mt-auto pt-[16px] border-t border-[#ffffff1a] hidden" id="cc-carousel-controls">
              <div class="text-[#ffffff80] text-[12px] font-['Raleway'] mb-[12px] text-center" id="cc-carousel-status">
                1 of 6 submitters have completed
              </div>
              <div class="flex gap-[8px]">
                <button id="cc-carousel-prev" class="flex-1 py-[12px] rounded-[8px] bg-[#ffffff1a] text-white hover:bg-[#ffffff33] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center" aria-label="Previous submitter">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
                </button>
                <button id="cc-carousel-next" class="flex-1 py-[12px] rounded-[8px] bg-[#ffffff1a] text-white hover:bg-[#ffffff33] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center" aria-label="Next submitter">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>
                </button>
              </div>
            </div>
          </div>

          <!-- 2. Mobile/Tablet Header (visible on < lg) -->
          <div class="flex lg:hidden flex-col bg-white border-b border-gray-100 shrink-0 px-4 pt-3.5 pb-3 gap-2 z-10 shadow-sm">

            <!-- Top Submitter Navigation & Details Row -->
            <div class="flex items-center justify-between gap-2">
              <button id="cc-mobile-prev" class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-[#043f42] flex items-center justify-center shrink-0 disabled:opacity-30 disabled:cursor-not-allowed transition-colors" aria-label="Previous submitter">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <div class="flex-1 min-w-0 flex flex-col items-center justify-center text-center">
                <!-- Row 1: Learner Name -->
                <h3 id="cc-mobile-submitter-name" class="text-[#043f42] text-[16px] sm:text-[18px] font-bold font-['Raleway'] truncate max-w-full">Glen Caddy</h3>
                <!-- Row 2: Completed date pill, centered on the same vertical axis directly below -->
                <div class="flex items-center justify-center mt-1">
                  <span id="cc-mobile-submitter-date" class="text-[11px] font-semibold font-['Raleway'] px-2.5 py-0.5 rounded-full bg-[#c6f6d5] text-[#22543d] inline-flex items-center justify-center">Completed on 10 Oct</span>
                </div>
              </div>
              <div class="flex items-center gap-1 shrink-0">
                <button id="cc-mobile-next" class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-[#043f42] flex items-center justify-center disabled:opacity-30 disabled:cursor-not-allowed transition-colors" aria-label="Next submitter">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>
                </button>
                <button id="cc-mobile-close" class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-gray-800 flex items-center justify-center ml-1 transition-colors" aria-label="Close modal">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 18L18 6M6 6l12 12"/></svg>
                </button>
              </div>
            </div>

            <!-- Mobile Tabs: Main vs Attachments -->
            <div class="flex gap-2 p-1 bg-[#f4f7f6] rounded-[10px]">
              <button id="cc-mobile-tab-main" class="flex-1 py-1.5 rounded-[8px] text-[12px] font-bold uppercase tracking-wider transition-all bg-[#043f42] text-white shadow-sm">Main</button>
              <button id="cc-mobile-tab-attachments" class="flex-1 py-1.5 rounded-[8px] text-[12px] font-bold uppercase tracking-wider transition-all text-gray-500 hover:text-[#043f42]">Attachments</button>
            </div>

            <!-- Mobile Document Switcher (Pills - horizontally scrollable) -->
            <div id="cc-mobile-docs-bar" class="w-full flex items-center gap-2 overflow-x-auto hide-scrollbar py-1 shrink-0">
              <!-- Rendered via JS -->
            </div>
          </div>

          <!-- 3. Right / Content Stage -->
          <div class="flex-1 bg-[#f4f4f4] p-3 sm:p-4 lg:p-[32px] flex flex-col gap-3 lg:gap-[24px] min-h-0 min-w-0 relative">
            
            <!-- Desktop Header (hidden on mobile/tablet < lg) -->
            <div class="hidden lg:flex justify-between items-center w-full">
              <div class="flex flex-col gap-[4px]">
                <div id="cc-submitter-name" class="text-[#1a202c] text-[24px] font-bold font-['Raleway']">Name</div>
                <div class="bg-[#c6f6d5] px-[12px] py-[4px] rounded-[16px] self-start">
                  <span id="cc-submitter-date" class="text-[#22543d] text-[12px] font-semibold font-['Raleway']">Completed on Date</span>
                </div>
              </div>
              <button id="cc-close" class="bg-white border border-[#e2e8f0] p-[12px] rounded-[12px] hover:bg-[#f8fff8] hover:border-[#22ec9b] hover:text-[#043f42] text-[#a0aec0] transition-all shadow-sm group" aria-label="Close modal">
                <svg class="w-7 h-7 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
              </button>
            </div>
            
            <!-- PDF View Area (Shared Stage) -->
            <div class="flex-1 flex flex-col min-h-0 min-w-0 overflow-hidden relative" id="cc-stage">
              <div class="m-auto text-[#a0aec0] text-[20px] lg:text-[24px] font-['Raleway']">[ PDF Rendered Here ]</div>
            </div>
          </div>
        </div>
      </div>
    `

    this.overlay = this.querySelector('#cc-overlay')
    this.closeBtn = this.querySelector('#cc-close')
    this.mobileCloseBtn = this.querySelector('#cc-mobile-close')
    this.sidebarContent = this.querySelector('#cc-sidebar-content')
    this.sidebarFooter = this.querySelector('#cc-sidebar-footer')
    this.stage = this.querySelector('#cc-stage')
    this.nameEl = this.querySelector('#cc-submitter-name')
    this.dateEl = this.querySelector('#cc-submitter-date')
    this.mobileNameEl = this.querySelector('#cc-mobile-submitter-name')
    this.mobileDateEl = this.querySelector('#cc-mobile-submitter-date')
    this.mobileDocsBar = this.querySelector('#cc-mobile-docs-bar')
    this.downloadBtn = this.querySelector('#cc-download-attachments')

    this.tabMain = this.querySelector('#cc-tab-main')
    this.tabAttachments = this.querySelector('#cc-tab-attachments')
    this.mobileTabMain = this.querySelector('#cc-mobile-tab-main')
    this.mobileTabAttachments = this.querySelector('#cc-mobile-tab-attachments')

    this.closeBtn.addEventListener('click', () => this.close())
    if (this.mobileCloseBtn) {
      this.mobileCloseBtn.addEventListener('click', () => this.close())
    }
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close()
    })

    this.carouselControls = this.querySelector('#cc-carousel-controls')
    this.carouselStatus = this.querySelector('#cc-carousel-status')
    this.carouselPrev = this.querySelector('#cc-carousel-prev')
    this.carouselNext = this.querySelector('#cc-carousel-next')
    this.mobileCarouselStatus = this.querySelector('#cc-mobile-carousel-status')
    this.mobilePrev = this.querySelector('#cc-mobile-prev')
    this.mobileNext = this.querySelector('#cc-mobile-next')

    this.carouselPrev.addEventListener('click', () => this.navigateCarousel(-1))
    this.carouselNext.addEventListener('click', () => this.navigateCarousel(1))
    if (this.mobilePrev) {
      this.mobilePrev.addEventListener('click', () => this.navigateCarousel(-1))
    }
    if (this.mobileNext) {
      this.mobileNext.addEventListener('click', () => this.navigateCarousel(1))
    }

    // Touch swipe navigation for mobile/tablet drawer
    let touchStartX = 0
    let touchStartY = 0
    this.stage.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX
      touchStartY = e.changedTouches[0].screenY
    }, { passive: true })

    this.stage.addEventListener('touchend', (e) => {
      const touchEndX = e.changedTouches[0].screenX
      const touchEndY = e.changedTouches[0].screenY
      const diffX = touchEndX - touchStartX
      const diffY = touchEndY - touchStartY
      if (Math.abs(diffX) > 50 && Math.abs(diffX) > Math.abs(diffY) * 1.5) {
        if (diffX < 0) {
          this.navigateCarousel(1) // Swipe left -> Next submitter
        } else {
          this.navigateCarousel(-1) // Swipe right -> Previous submitter
        }
      }
    }, { passive: true })

    this.dataScript = document.getElementById('command-centre-data')
    if (this.dataScript) {
      try {
        const parsed = JSON.parse(this.dataScript.textContent)
        this.dataStore = parsed.data || {}
        this.dataOrder = (parsed.order || []).map(id => id.toString())
      } catch (e) {
        console.error('Failed to parse Command Centre data', e)
        this.dataStore = {}
        this.dataOrder = []
      }
    } else {
      this.dataStore = {}
      this.dataOrder = []
    }

    this.openHandler = this.open.bind(this)
    window.addEventListener('command-centre:open', this.openHandler)

    this.tabMain.addEventListener('click', () => this.switchTab('main'))
    this.tabAttachments.addEventListener('click', () => this.switchTab('attachments'))
    if (this.mobileTabMain) {
      this.mobileTabMain.addEventListener('click', () => this.switchTab('main'))
    }
    if (this.mobileTabAttachments) {
      this.mobileTabAttachments.addEventListener('click', () => this.switchTab('attachments'))
    }
  }

  disconnectedCallback () {
    window.removeEventListener('command-centre:open', this.openHandler)
  }

  close () {
    this.overlay.classList.remove('flex')
    this.overlay.classList.add('hidden')
    this.stage.innerHTML = '<div class="m-auto text-[#a0aec0] text-[20px] font-[\'Raleway\']">[ PDF Rendered Here ]</div>'
    if (this.currentBlobUrl) {
      URL.revokeObjectURL(this.currentBlobUrl)
      this.currentBlobUrl = null
    }
  }

  switchTab (tab) {
    this.activeTab = tab
    if (tab === 'attachments' && this.hasAttachments === false) return

    if (tab === 'main') {
      // Desktop styling
      this.tabMain.classList.add('bg-[#043f42]', 'text-white', 'shadow-sm')
      this.tabMain.classList.remove('text-[#ffffff80]', 'hover:text-white')
      this.tabAttachments.classList.remove('bg-[#043f42]', 'text-white', 'shadow-sm')
      this.tabAttachments.classList.add('text-[#ffffff80]', 'hover:text-white')
      this.sidebarContent.innerHTML = this.mainDocsHtml
      if (this.sidebarFooter) this.sidebarFooter.style.visibility = 'hidden'

      // Mobile styling
      if (this.mobileTabMain && this.mobileTabAttachments) {
        this.mobileTabMain.className = 'flex-1 py-1.5 rounded-[8px] text-[12px] font-bold uppercase tracking-wider transition-all bg-[#043f42] text-white shadow-sm'
        this.mobileTabAttachments.className = 'flex-1 py-1.5 rounded-[8px] text-[12px] font-bold uppercase tracking-wider transition-all text-gray-500 hover:text-[#043f42]'
      }
      if (this.mobileDocsBar) this.mobileDocsBar.innerHTML = this.mobileMainDocsHtml
    } else {
      // Desktop styling
      this.tabAttachments.classList.add('bg-[#043f42]', 'text-white', 'shadow-sm')
      this.tabAttachments.classList.remove('text-[#ffffff80]', 'hover:text-white')
      this.tabMain.classList.remove('bg-[#043f42]', 'text-white', 'shadow-sm')
      this.tabMain.classList.add('text-[#ffffff80]', 'hover:text-white')
      this.sidebarContent.innerHTML = this.attachmentsHtml
      if (this.sidebarFooter) this.sidebarFooter.style.visibility = 'visible'

      // Mobile styling
      if (this.mobileTabMain && this.mobileTabAttachments) {
        this.mobileTabAttachments.className = 'flex-1 py-1.5 rounded-[8px] text-[12px] font-bold uppercase tracking-wider transition-all bg-[#043f42] text-white shadow-sm'
        this.mobileTabMain.className = 'flex-1 py-1.5 rounded-[8px] text-[12px] font-bold uppercase tracking-wider transition-all text-gray-500 hover:text-[#043f42]'
      }
      if (this.mobileDocsBar) this.mobileDocsBar.innerHTML = this.mobileAttachmentsHtml
    }

    // Attach desktop document button listeners
    this.sidebarContent.querySelectorAll('.cc-item-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        this.sidebarContent.querySelectorAll('.cc-item-btn').forEach(b => {
          b.classList.remove('bg-[#ffffff1a]', 'text-white')
          b.classList.add('text-[#a0aec0]')
          if (b.parentElement.classList.contains('group')) {
            b.parentElement.classList.remove('bg-[#ffffff1a]')
          }
        })

        btn.classList.add('bg-[#ffffff1a]', 'text-white')
        btn.classList.remove('text-[#a0aec0]')
        if (btn.parentElement.classList.contains('group')) {
          btn.parentElement.classList.add('bg-[#ffffff1a]')
        }

        const url = btn.dataset.url
        const filename = btn.textContent.trim()
        const signedUuid = btn.dataset.signedUuid
        const numberOfPages = btn.dataset.numberOfPages ? parseInt(btn.dataset.numberOfPages, 10) : null
        this.renderStage(url, filename, signedUuid, numberOfPages)
      })
    })

    // Attach mobile document button listeners
    if (this.mobileDocsBar) {
      this.mobileDocsBar.querySelectorAll('.cc-mobile-item-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          this.mobileDocsBar.querySelectorAll('.cc-mobile-item-btn').forEach(b => {
            b.className = 'cc-mobile-item-btn px-3.5 py-1.5 rounded-full text-xs font-normal whitespace-nowrap border border-black/20 text-black/70 hover:border-black/40 hover:text-black bg-transparent transition-all shrink-0 flex items-center gap-1.5'
          })
          btn.className = 'cc-mobile-item-btn px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap border border-black/50 text-black/90 bg-transparent transition-all shrink-0 flex items-center gap-1.5'

          const url = btn.dataset.url
          const filename = btn.textContent.trim()
          const signedUuid = btn.dataset.signedUuid
          const numberOfPages = btn.dataset.numberOfPages ? parseInt(btn.dataset.numberOfPages, 10) : null
          this.renderStage(url, filename, signedUuid, numberOfPages)
        })
      })
    }

    // Trigger click on first available doc
    const firstMobileDoc = this.mobileDocsBar ? this.mobileDocsBar.querySelector('.cc-mobile-item-btn') : null
    const firstDoc = this.sidebarContent.querySelector('.cc-item-btn')
    if (firstMobileDoc) {
      firstMobileDoc.click()
    }
    if (firstDoc) {
      firstDoc.click()
    } else if (!firstMobileDoc) {
      const roleLabel = (this.currentSubmitterData && this.currentSubmitterData.student_name) ? 'student' : 'signatory'
      if (this.isSubmitterCompleted) {
        this.stage.innerHTML = '<div class="m-auto text-[#a0aec0] text-[20px] font-[\'Raleway\']">No documents available</div>'
      } else {
        this.stage.innerHTML = `<div class="m-auto text-[#a0aec0] text-[20px] font-['Raleway'] text-center">Waiting for ${roleLabel}<br/>to complete their signing.</div>`
      }
    }
  }

  open (e) {
    const { submitterId, order } = e.detail

    if (order && Array.isArray(order)) {
      this.dataOrder = order.map(id => id.toString())
    }

    if (!this.dataStore || Object.keys(this.dataStore).length === 0 || (!this.dataStore[submitterId] && !this.dataStore[submitterId?.toString()])) {
      this.dataScript = document.getElementById('command-centre-data')
      if (this.dataScript) {
        try {
          const parsed = JSON.parse(this.dataScript.textContent)
          this.dataStore = parsed.data || {}
          this.dataOrder = (parsed.order || []).map(id => id.toString())
        } catch (err) {}
      }
    }

    const submitterData = this.dataStore[submitterId] || this.dataStore[submitterId?.toString()]

    if (!submitterData) {
      console.error('No data found for submitter', submitterId)
      return
    }

    this.currentSubmitterData = submitterData
    const isCohort = !!submitterData.is_cohort || (!submitterData.is_folio && !!submitterData.student_name && !submitterData.signatory_name)
    const roleTitle = isCohort ? 'Student' : 'Signatory'
    const roleLabel = isCohort ? 'student' : 'signatory'

    const totalSubmittersCount = this.dataOrder.length

    if (totalSubmittersCount > 1) {
      this.currentCarouselIndex = this.dataOrder.indexOf(submitterId.toString())
      if (this.currentCarouselIndex === -1) this.currentCarouselIndex = 0

      this.carouselControls.classList.remove('hidden')
      this.carouselStatus.textContent = `${roleTitle} ${this.currentCarouselIndex + 1} of ${totalSubmittersCount}`

      this.carouselPrev.disabled = this.currentCarouselIndex <= 0
      this.carouselNext.disabled = this.currentCarouselIndex >= totalSubmittersCount - 1

      if (this.mobileCarouselStatus) {
        this.mobileCarouselStatus.textContent = `${this.currentCarouselIndex + 1} of ${totalSubmittersCount}`
      }
      if (this.mobilePrev) {
        this.mobilePrev.disabled = this.currentCarouselIndex <= 0
      }
      if (this.mobileNext) {
        this.mobileNext.disabled = this.currentCarouselIndex >= totalSubmittersCount - 1
      }
    } else {
      this.carouselControls.classList.add('hidden')
      if (this.mobileCarouselStatus) this.mobileCarouselStatus.textContent = '1 of 1'
      if (this.mobilePrev) this.mobilePrev.disabled = true
      if (this.mobileNext) this.mobileNext.disabled = true
    }

    // Prioritize specific signatory/learner full name over template/sponsor names
    const displayName = submitterData.signatory_name || submitterData.student_name || submitterData.name || submitterData.role || submitterData.email || roleTitle
    this.nameEl.textContent = displayName
    if (this.mobileNameEl) {
      this.mobileNameEl.textContent = displayName
    }

    const completedAt = submitterData.student_completed_at || submitterData.completed_at
    const status = submitterData.student_status || submitterData.status
    if (completedAt) {
      const dateStr = new Date(completedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
      const text = `Completed on ${dateStr}`
      this.dateEl.textContent = text
      if (this.mobileDateEl) {
        this.mobileDateEl.textContent = text
        this.mobileDateEl.className = 'text-[11px] font-semibold font-[\'Raleway\'] px-2 py-0.5 rounded-full bg-[#c6f6d5] text-[#22543d]'
      }
    } else if (status === 'waiting') {
      const text = 'Not Sent'
      this.dateEl.textContent = text
      if (this.mobileDateEl) {
        this.mobileDateEl.textContent = text
        this.mobileDateEl.className = 'text-[11px] font-semibold font-[\'Raleway\'] px-2 py-0.5 rounded-full bg-gray-100 text-gray-700'
      }
    } else {
      const text = 'In Progress'
      this.dateEl.textContent = text
      if (this.mobileDateEl) {
        this.mobileDateEl.textContent = text
        this.mobileDateEl.className = 'text-[11px] font-semibold font-[\'Raleway\'] px-2 py-0.5 rounded-full bg-[#fef3c7] text-[#92400e]'
      }
    }

    this.mainDocsHtml = ''
    this.mobileMainDocsHtml = ''
    const documents = submitterData.documents || []
    if (documents.length > 0) {
      this.mainDocsHtml += '<ul class="flex flex-col gap-[12px]">'
      documents.forEach((doc, idx) => {
        const docName = doc.name || 'Document ' + (idx + 1)
        this.mainDocsHtml += `
          <li>
            <button class="cc-item-btn w-full text-left p-[12px] rounded-[8px] flex justify-between items-center text-[#a0aec0] hover:bg-[#ffffff1a] hover:text-white transition-colors text-[14px] font-['Raleway'] truncate" data-url="${doc.url}" data-signed-uuid="${doc.signed_uuid}" data-number-of-pages="${doc.number_of_pages}">
              <span>${docName}</span>
            </button>
          </li>
        `
        this.mobileMainDocsHtml += `
          <button class="cc-mobile-item-btn px-3.5 py-1.5 rounded-full text-xs font-normal whitespace-nowrap border border-black/20 text-black/70 hover:border-black/40 hover:text-black bg-transparent transition-all shrink-0 flex items-center gap-1.5" data-url="${doc.url}" data-signed-uuid="${doc.signed_uuid}" data-number-of-pages="${doc.number_of_pages}">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            <span>${docName}</span>
          </button>
        `
      })
      this.mainDocsHtml += '</ul>'
    } else {
      if (submitterData.completed_at) {
        this.mainDocsHtml = '<div class="text-[#ffffff80] text-[14px] text-center mt-[24px]">No main documents found.</div>'
        this.mobileMainDocsHtml = '<div class="text-gray-400 text-xs py-1">No documents found.</div>'
      } else {
        this.mainDocsHtml = `<div class="text-[#ffffff80] text-[14px] text-center mt-[24px] px-[12px]">Waiting for ${roleLabel} to complete their signing.</div>`
        this.mobileMainDocsHtml = `<div class="text-gray-400 text-xs py-1">Waiting for ${roleLabel} to complete signing.</div>`
      }
    }

    const attachments = []
    const seenAttachmentUrls = new Set()

    const addAttachment = (item) => {
      if (!item || !item.url) return
      const cleanUrl = item.url.split('?')[0].toLowerCase()
      const cleanName = (item.name || '').trim().toLowerCase()
      const dedupKey = `${cleanUrl}::${cleanName}`
      if (seenAttachmentUrls.has(dedupKey) || seenAttachmentUrls.has(cleanUrl)) return
      seenAttachmentUrls.add(dedupKey)
      seenAttachmentUrls.add(cleanUrl)
      attachments.push(item)
    }

    // 1. Check explicit attachments array from backend (submitter's non-signature uploads)
    if (Array.isArray(submitterData.attachments) && submitterData.attachments.length > 0) {
      submitterData.attachments.forEach(att => {
        addAttachment({
          name: att.filename || att.name || 'Attachment',
          url: att.url,
          signed_uuid: att.signed_uuid || null,
          number_of_pages: att.number_of_pages || null
        })
      })
    }

    // 2. Only if no explicit attachments were provided, check file_metadata in submitter values as fallback
    if (attachments.length === 0) {
      ;(submitterData.values || []).forEach(val => {
        if (!val.file_metadata || val.file_metadata.length === 0) return

        if (Array.isArray(val.value)) {
          val.value.forEach((url, idx) => {
            const meta = val.file_metadata[idx]
            addAttachment({
              name: `${val.field} (Part ${idx + 1})`,
              url,
              signed_uuid: meta ? meta.signed_uuid : null,
              number_of_pages: meta ? meta.number_of_pages : null
            })
          })
        } else if (typeof val.value === 'string' && val.value) {
          const meta = val.file_metadata[0]
          addAttachment({
            name: val.field,
            url: val.value,
            signed_uuid: meta ? meta.signed_uuid : null,
            number_of_pages: meta ? meta.number_of_pages : null
          })
        }
      })
    }

    this.hasAttachments = attachments.length > 0
    this.attachmentsHtml = ''
    this.mobileAttachmentsHtml = ''

    if (this.hasAttachments) {
      this.attachmentsHtml += '<ul class="flex flex-col gap-[12px]">'
      attachments.forEach((att) => {
        let filename = att.name
        if (att.url) {
          try {
            const urlObj = new URL(att.url)
            const pathParts = urlObj.pathname.split('/')
            const lastPart = pathParts[pathParts.length - 1]
            if (lastPart && !lastPart.startsWith('http')) {
              filename = decodeURIComponent(lastPart)
            }
          } catch (err) {}
        }

        this.attachmentsHtml += `
          <li>
            <div class="w-full flex justify-between items-center text-[#a0aec0] hover:bg-[#ffffff1a] hover:text-white transition-colors rounded-[8px] group">
              <button class="cc-item-btn flex-1 text-left p-[12px] text-[14px] font-['Raleway'] truncate" data-url="${att.url}" data-signed-uuid="${att.signed_uuid || ''}" data-number-of-pages="${att.number_of_pages || ''}">
                ${filename}
              </button>
              <a href="${att.url}" target="_blank" class="p-[12px] opacity-0 group-hover:opacity-100 transition-opacity" title="Download">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/></svg>
              </a>
            </div>
          </li>
        `

        this.mobileAttachmentsHtml += `
          <button class="cc-mobile-item-btn px-3.5 py-1.5 rounded-full text-xs font-normal whitespace-nowrap border border-black/20 text-black/70 hover:border-black/40 hover:text-black bg-transparent transition-all shrink-0 flex items-center gap-1.5" data-url="${att.url}" data-signed-uuid="${att.signed_uuid || ''}" data-number-of-pages="${att.number_of_pages || ''}">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>
            <span>${filename}</span>
          </button>
        `
      })
      this.attachmentsHtml += '</ul>'
      this.mobileAttachmentsHtml += `
        <a href="/submitters/${submitterId}/attachments_export" class="ml-auto px-2.5 py-1.5 rounded-full text-[11px] font-medium border border-black/30 text-black/80 hover:border-black/60 hover:text-black bg-transparent shrink-0 whitespace-nowrap transition-colors flex items-center gap-1">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/></svg>
          <span>Download All</span>
        </a>
      `

      this.tabAttachments.classList.remove('opacity-50', 'cursor-not-allowed')
      if (this.mobileTabAttachments) {
        this.mobileTabAttachments.classList.remove('opacity-50', 'cursor-not-allowed')
      }
      this.downloadBtn.href = `/submitters/${submitterId}/attachments_export`
      if (this.activeTab === 'attachments') this.sidebarFooter.style.visibility = 'visible'
    } else {
      if (submitterData.completed_at) {
        this.attachmentsHtml = '<div class="text-[#ffffff80] text-[14px] text-center mt-[24px]">No attachments uploaded yet.</div>'
        this.mobileAttachmentsHtml = '<div class="text-gray-400 text-xs py-1">No attachments uploaded yet.</div>'
      } else {
        this.attachmentsHtml = `<div class="text-[#ffffff80] text-[14px] text-center mt-[24px] px-[12px]">Waiting for ${roleLabel} to complete their signing.</div>`
        this.mobileAttachmentsHtml = `<div class="text-gray-400 text-xs py-1">Waiting for ${roleLabel} to complete signing.</div>`
      }
      this.tabAttachments.classList.add('opacity-50', 'cursor-not-allowed')
      if (this.mobileTabAttachments) {
        this.mobileTabAttachments.classList.add('opacity-50', 'cursor-not-allowed')
      }
      this.sidebarFooter.style.visibility = 'hidden'
    }

    this.isSubmitterCompleted = !!submitterData.completed_at

    const initialTab = (e.detail?.tab === 'attachments' && this.hasAttachments) ? 'attachments' : 'main'
    this.switchTab(initialTab)

    this.overlay.classList.remove('hidden')
    this.overlay.classList.add('flex')
  }

  renderStage (url, filename = '') {
    if (this.currentBlobUrl) {
      URL.revokeObjectURL(this.currentBlobUrl)
      this.currentBlobUrl = null
    }

    if (!url) {
      this.stage.innerHTML = '<div class="m-auto text-[#a0aec0] text-[20px] font-[\'Raleway\']">Failed to load document</div>'
      return
    }

    let cleanUrl = url.trim()
    try {
      const urlObj = new URL(cleanUrl, window.location.origin)
      if (urlObj.origin === window.location.origin || urlObj.pathname.startsWith('/blobs/') || urlObj.pathname.startsWith('/file/')) {
        cleanUrl = urlObj.pathname + urlObj.search + urlObj.hash
      }
    } catch (e) {}

    const cleanFilename = (filename || '').trim().toLowerCase()
    const isImage = /\.(png|jpe?g|webp|svg|gif)($|\?)/i.test(cleanUrl) || /\.(png|jpe?g|webp|svg|gif)$/i.test(cleanFilename)

    if (isImage) {
      this.stage.innerHTML = `
        <div class="relative w-full h-full flex items-center justify-center p-3 sm:p-4 doccu-scrollbar bg-white rounded-[16px] border border-black/[0.08] shadow-xs overflow-auto">
          <div id="cc-stage-loader" class="absolute inset-0 flex flex-col items-center justify-center bg-white/90 z-10 transition-opacity duration-200 pointer-events-none">
            <svg class="animate-spin h-8 w-8 mb-3 text-[#01d680]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span class="text-[13px] font-semibold text-[#043f42] font-['Raleway']">Loading image...</span>
          </div>
          <img src="${cleanUrl}"
               alt="${filename || 'Attachment'}"
               class="max-w-full max-h-full object-contain rounded select-none" />
        </div>
      `

      const loader = this.stage.querySelector('#cc-stage-loader')
      const img = this.stage.querySelector('img')
      const dismissLoader = () => {
        if (loader && loader.isConnected) {
          loader.style.opacity = '0'
          setTimeout(() => { if (loader.isConnected) loader.remove() }, 200)
        }
      }

      if (img) {
        if (img.complete && img.naturalWidth > 0) {
          dismissLoader()
        } else {
          img.addEventListener('load', dismissLoader, { once: true })
          img.addEventListener('error', () => {
            dismissLoader()
            this.stage.innerHTML = '<div class="m-auto text-red-500 font-semibold font-[\'Raleway\']">Failed to load image</div>'
          }, { once: true })
          // Safety timeout for cached/ambient images
          setTimeout(dismissLoader, 1000)
        }
      }
      return
    }

    // Direct, ultra-fast PDF streaming via native iframe (< 1s, zero server-side rasterization)
    this.stage.innerHTML = `
      <div class="relative w-full h-full flex flex-col items-center justify-center bg-white rounded-[16px] border border-black/[0.08] shadow-xs overflow-hidden">
        <div id="cc-stage-loader" class="absolute inset-0 flex flex-col items-center justify-center bg-[#f9fafb]/90 z-10 transition-opacity duration-200 pointer-events-none">
          <svg class="animate-spin h-9 w-9 mb-3 text-[#01d680]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <span class="text-[13px] font-semibold text-[#043f42] font-['Raleway']">Opening PDF...</span>
        </div>
        <iframe src="${cleanUrl}#view=FitH"
                class="w-full h-full border-none rounded-[16px]"
                title="${filename || 'Document'}">
        </iframe>
      </div>
    `

    const loader = this.stage.querySelector('#cc-stage-loader')
    const iframe = this.stage.querySelector('iframe')
    const dismissLoader = () => {
      if (loader && loader.isConnected) {
        loader.style.opacity = '0'
        setTimeout(() => { if (loader.isConnected) loader.remove() }, 200)
      }
    }

    if (iframe) {
      iframe.addEventListener('load', dismissLoader, { once: true })
    }
    // High-performance safety dismissal: Native PDF plugins do not reliably bubble iframe load
    setTimeout(dismissLoader, 400)
  }

  navigateCarousel (direction) {
    if (!this.dataOrder || this.dataOrder.length === 0) return
    const nextIndex = this.currentCarouselIndex + direction
    if (nextIndex >= 0 && nextIndex < this.dataOrder.length) {
      const nextSubmitterId = this.dataOrder[nextIndex]
      this.open({ detail: { submitterId: nextSubmitterId, order: this.dataOrder, tab: this.activeTab } })
    }
  }
}
